module.exports = __webpack_public_path__ + "static/media/0272_Small.65ad6da9.jpg";